import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import USER_ACTIVITY_POST_DETAIL_PAGE_CHILDREN from './userActivityPostDetailPageChildren';

export default defineSection({
    resetScroll: true,
    head: sectionHead({icon: FAVICONS.circle}),
    routes: [
        {
            path: '/users/user_post_detail/:postId(\\d+)/',
            component: () => import(/* webpackChunkName: "activityPost" */ './UserActivityPostDetailPage'),
            children: USER_ACTIVITY_POST_DETAIL_PAGE_CHILDREN,
            props: true,
        },
    ]
});
